// extracted by mini-css-extract-plugin
export var pillWrapper = "_yf-0";
export var showOverflow = "_yf-1";